<template>
    <div class="tabs-container">
        <div class="tabs-nav">
            <nav class="">
                <ul class="flex flex-wrap flex-row -mt-4">
                    <li
                        v-for="tab in tabs"
                        :class="{ active: tab.isActive }"
                        class="mt-4 place-self-start"
                    >
                        <a :href="tab.href" @click="selectTab(tab)" class="">{{
                            tab.name
                        }}</a>
                    </li>
                </ul>
            </nav>
        </div>

        <div class="tabs-content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return { tabs: [] };
    },

    created() {
        this.tabs = this.$children;
    },
    mounted() {},
    methods: {
        selectTab(selectedTab) {
            this.tabs.forEach((tab) => {
                tab.isActive = tab.href == selectedTab.href;
            });
        },
    },
};
</script>

<style></style>
